import { Search } from "@outschool/business-rules";
import { TFunction, useTranslation } from "@outschool/localization";
import React from "react";

function translateRelativeDateFilter({
  dateFilter,
  t,
}: {
  dateFilter?: Search.RelativeDateFilter | null;
  t: TFunction;
}): string | null {
  switch (dateFilter) {
    case Search.RelativeDateFilter.ThisWeek:
      return t("Starting this week or later");
    case Search.RelativeDateFilter.NextWeek:
      return t("Starting next week or later");
    case Search.RelativeDateFilter.NextMonth:
      return t("Starting next month or later");
    case Search.RelativeDateFilter.Today:
      return t("Today");
    case Search.RelativeDateFilter.SevenDays:
      return t("Next 7 days");
    case Search.RelativeDateFilter.FourteenDays:
      return t("Next 14 days");
    case Search.RelativeDateFilter.Summer:
      return t("Summer");
    case Search.RelativeDateFilter.Fall:
      return t("Fall");
    case Search.RelativeDateFilter.January:
      return t("January {{date}}", { date: new Date().getFullYear() + 1 });
    case Search.RelativeDateFilter.AllUpcoming:
      return t("All upcoming dates");
    default:
      return null;
  }
}

function isRelativeDateFilter(
  dateFilter: any
): dateFilter is Search.RelativeDateFilter {
  return Object.values(Search.RelativeDateFilter).includes(dateFilter);
}

export function useTranslateRelativeDateFilter() {
  const { t } = useTranslation(
    "ui-components-website\\src\\Search\\translations\\useTranslateRelativeDateFilter"
  );

  return React.useCallback(
    (dateFilter?: string | Search.RelativeDateFilter | null) => {
      if (!isRelativeDateFilter(dateFilter)) {
        return null;
      }
      return translateRelativeDateFilter({ dateFilter, t });
    },
    [t]
  );
}
